import React from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import VisuallyHidden from '@atlaskit/visually-hidden';
export var accessibilityUtilsPluginKey = new PluginKey('accessibilityUtilsPlugin');
export var accessibilityUtilsPlugin = function accessibilityUtilsPlugin(_ref) {
  var api = _ref.api;
  var editorView;
  var setEditorView = function setEditorView(newEditorView) {
    editorView = newEditorView;
  };
  return {
    name: 'accessibilityUtils',
    actions: {
      ariaNotify: function ariaNotify(message) {
        if (!editorView) {
          // at time of writing, this should never happen
          return;
        }
        var tr = editorView.state.tr;
        tr.setMeta(accessibilityUtilsPluginKey, {
          message: message
        });
        editorView.dispatch(tr);
        return;
      }
    },
    contentComponent: function contentComponent() {
      return /*#__PURE__*/React.createElement(ContentComponent, {
        api: api
      });
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return null;
      }
      return accessibilityUtilsPluginKey.getState(editorState);
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'get-editor-view',
        plugin: function plugin() {
          return new SafePlugin({
            key: accessibilityUtilsPluginKey,
            state: {
              init: function init() {
                return {
                  message: ''
                };
              },
              apply: function apply(tr, prevState) {
                var meta = tr.getMeta(accessibilityUtilsPluginKey);
                if (meta && 'message' in meta) {
                  return {
                    message: meta.message
                  };
                }
                return prevState;
              }
            },
            view: function view(editorView) {
              setEditorView(editorView);
              return {};
            }
          });
        }
      }];
    }
  };
};
function ContentComponent(_ref2) {
  var api = _ref2.api;
  var _useSharedPluginState = useSharedPluginState(api, ['accessibilityUtils']),
    accessibilityUtilsState = _useSharedPluginState.accessibilityUtilsState;
  return /*#__PURE__*/React.createElement(VisuallyHidden, {
    role: "alert"
  }, accessibilityUtilsState === null || accessibilityUtilsState === void 0 ? void 0 : accessibilityUtilsState.message);
}